
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!conversations.message";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'conversations/message';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  
  return "read";
  }

function program3(depth0,data) {
  
  
  return "true";
  }

function program5(depth0,data) {
  
  
  return "false";
  }

function program7(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "mark_as_read_e7de2ce3", "Mark as read", options) : helperMissing.call(depth0, "t", "mark_as_read_e7de2ce3", "Mark as read", options)));
  }

function program9(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "mark_as_unread_4a413c41", "Mark as unread", options) : helperMissing.call(depth0, "t", "mark_as_unread_4a413c41", "Mark as unread", options)));
  }

function program11(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      ";
  if (helper = helpers.subject) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.subject); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n    ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      ("
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "no_subject_970aad80", "No subject", options) : helperMissing.call(depth0, "t", "no_subject_970aad80", "No subject", options)))
    + ")\n    ";
  return buffer;
  }

function program15(depth0,data) {
  
  var stack1, helper;
  if (helper = helpers.last_message) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.last_message); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  return escapeExpression(stack1);
  }

function program17(depth0,data) {
  
  var stack1, helper;
  if (helper = helpers.last_authored_message) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.last_authored_message); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  return escapeExpression(stack1);
  }

function program19(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <span class=\"StarButton-LabelContainer\" id=\"star_button_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" style=\"display: none;\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.starred), {hash:{},inverse:self.program(25, program25, data),fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </span>\n  <a href=\"#\"\n      class=\"star-btn ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.starred), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n      title=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.starred), {hash:{},inverse:self.program(34, program34, data),fn:self.program(32, program32, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n      aria-checked=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.starred), {hash:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n      aria-labelledby=\"star_button_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n      role=\"checkbox\"></a>\n  ";
  return buffer;
  }
function program20(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.subject), {hash:{},inverse:self.program(23, program23, data),fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program21(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'subject': ((depth0 && depth0.subject)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "starred_subject_click_to_unstar_6aafcddc", "Starred \"%{subject}\", Click to unstar.", options) : helperMissing.call(depth0, "t", "starred_subject_click_to_unstar_6aafcddc", "Starred \"%{subject}\", Click to unstar.", options)))
    + "\n      ";
  return buffer;
  }

function program23(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "starred_no_subject_click_to_unstar_bff04bce", "Starred \"(No subject)\", Click to unstar.", options) : helperMissing.call(depth0, "t", "starred_no_subject_click_to_unstar_bff04bce", "Starred \"(No subject)\", Click to unstar.", options)))
    + "\n      ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.subject), {hash:{},inverse:self.program(28, program28, data),fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program26(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'subject': ((depth0 && depth0.subject)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "not_starred_subject_click_to_star_4ea6eb64", "Not starred \"%{subject}\", Click to star.", options) : helperMissing.call(depth0, "t", "not_starred_subject_click_to_star_4ea6eb64", "Not starred \"%{subject}\", Click to star.", options)))
    + "\n      ";
  return buffer;
  }

function program28(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "not_starred_no_subject_click_to_star_adfefe93", "'Not starred \"(No Subject)\", Click to star.", options) : helperMissing.call(depth0, "t", "not_starred_no_subject_click_to_star_adfefe93", "'Not starred \"(No Subject)\", Click to star.", options)))
    + "\n      ";
  return buffer;
  }

function program30(depth0,data) {
  
  
  return "active";
  }

function program32(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "unstar_conversation_45fc43d6", "Unstar conversation", options) : helperMissing.call(depth0, "t", "unstar_conversation_45fc43d6", "Unstar conversation", options)));
  }

function program34(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "star_conversation_2e2ba614", "Star conversation", options) : helperMissing.call(depth0, "t", "star_conversation_2e2ba614", "Star conversation", options)));
  }

  buffer += "<div class=\"message-left-column\">\n  <div class=\"select-checkbox\" id=\"conversation-checkbox-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    \n  </div>\n  <input href=\"#\"\n      class=\"read-state ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.unread), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n      type=\"checkbox\"\n      aria-checked=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.unread), {hash:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n      title=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.unread), {hash:{},inverse:self.program(9, program9, data),fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    <span class=\"screenreader-only\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "unread_e9c1b19c", "Unread", options) : helperMissing.call(depth0, "t", "unread_e9c1b19c", "Unread", options)))
    + "\n    </span>\n  </a>\n</div>\n\n<div class=\"message-middle-column\">\n  <div class=\"date\">"
    + escapeExpression((helper = helpers.friendlyDatetime || (depth0 && depth0.friendlyDatetime),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.timestamp), options) : helperMissing.call(depth0, "friendlyDatetime", (depth0 && depth0.timestamp), options)))
    + "</div>\n  <h2 class=\"author\">"
    + escapeExpression((helper = helpers.list || (depth0 && depth0.list),options={hash:{
    'propName': ("name"),
    'limit': (2)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.participants), options) : helperMissing.call(depth0, "list", (depth0 && depth0.participants), options)))
    + "</h2>\n  <h3 class=\"subject\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.subject), {hash:{},inverse:self.program(13, program13, data),fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </h3>\n  <div class=\"summary\">";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.last_message), {hash:{},inverse:self.program(17, program17, data),fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</div>\n</div>\n\n<div class=\"message-right-column\">\n  <span class=\"message-count label\">\n    ";
  if (helper = helpers.message_count) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.message_count); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "total_messages_af025be6", "Total messages", options) : helperMissing.call(depth0, "t", "total_messages_af025be6", "Total messages", options)))
    + "</span>\n  </span>\n\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.for_submission), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n<a href=\"#\" class=\"open-message\" role=\"button\">\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "open_message_d7b12975", "Open Message", options) : helperMissing.call(depth0, "t", "open_message_d7b12975", "Open Message", options)))
    + "\n</a>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  